export default __webpack_public_path__ + "img/course-maindish.png";